import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from "react-router";
import './index.css';
import App from './components/App';
import reportWebVitals from './reportWebVitals';

// Import Blog Pages
import UserInterfacesBlog from './components/pages/blogs/UserInterfacesBlog';

// Import HGS
import HGS from './components/pages/HGS';

// Import invites
import Birthday2026 from './components/pages/invites/Birthday2026';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="hgs" element={<HGS />} />
        <Route path="birthday2026" element={<Birthday2026 />} />
        <Route path="blog">
          <Route path="userinterfaces" element={<UserInterfacesBlog />} />
        </Route>
        <Route path="/" element={<App />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

